/* api query for sensorTypeName
 export  async function ex1 (ss, device) {
    // for one device
    const url = "/dcap-email-log/device-factory-configuration?device_id=81C00106"// +device.device_id
    //or for an entire site
    const url = "/dcap-email-log/device-factory-configuration?access_code="
              +siteAccessCode(this.props.getActiveSite(this.props.site))
    const resp = await ss.apiData(url)
    console.log (resp)

    todo add types 3, 12, 15
  } */

const sensorNameTable = {
  '01': {name: 'Internal Temp', seq: 90},
  '02': {name: 'Temperature', seq: 89},
  '08': {name: 'Contact', seq: 88},
  '50': {name: "Totalizer", seq: 1},
  '51': {name: "Pulse Totalizer 1", seq: 2},
  '52': {name: "Pulse Totalizer 2", seq: 3},
  '53': {name: "Encoded Meter", seq: 10},
  '54': {name: "Hersey Totalizer", seq: 4},
  '55': {name: "ToH Totalizer", seq: 5},
  '58': {name: "RunTime Counter", seq: 30},
  "59": {name: "RunTime lineCut", seq: 31},
  "5B": {name: "RunTime P1", seq: 32},
  "5C": {name: "RunTime P2", seq: 33},
  "5D": {name: "Encoded Meter 2", seq: 11},
  "67": {name: "Xmit Count", seq: 12},
  "71": {name: "GWF_AllRead Encoder_1", seq:20},
  "72": {name: "GWF_AllRead Encoder_2", seq: 21},
  "73": {name: "Umeter™ Read", seq: 22},
  "74": {name: "Umeter™ Status", seq: 23},
  "75": {name: "Umeter™ Temperature", seq: 24},
  "A0": {name: "Consumed Energy", seq:60},
  "A1": {name: "System Power", seq: 61},
  "A2": {name: "Power Factor", seq:62},
  "A3": {name: "Phase A Power", seq:63},
  "A4": {name: "Phase B Power", seq: 64},
  'A5': {name: "Phase C Power", seq: 65},
  'A6': {name: "Apparent Energy", seq: 66},
  "FD": {name: "PMT_Sensor", seq: 80},
  'FF': {name: "Unused", seq: 99},
}
export function sensorTypeName(typeString) {
  return sensorNameTable[typeString?.toUpperCase()]?.name ?? typeString
}

export function sensorDisplayOrder(arrSensors) {
  arrSensors.sort((a, b)=> (sensorNameTable[a]?.seq ?? 99) - (sensorNameTable[b]?.seq ?? 99));
}
